var render = function render(){
  var _vm$getValue, _vm$getValue2, _vm$bindValue;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    staticClass: "longtextfilter",
    attrs: {
      "id": _vm.filterLabelId,
      "label": _vm.label,
      "label-for": _vm.filterId,
      "data-test": "outside-vif"
    }
  }, [_c('div', {
    staticClass: "longtextfilter-row",
    attrs: {
      "id": _vm.filterWrapperId
    }
  }, [_c('div', {
    staticClass: "longtextfilter-col"
  }, [_vm.useShortText ? _c('b-form-input', {
    attrs: {
      "id": _vm.filterId,
      "value": (_vm$getValue = _vm.getValue) === null || _vm$getValue === void 0 ? void 0 : _vm$getValue.value
    },
    on: {
      "input": function ($e) {
        return _vm.updateFilter({
          value: $e,
          selected: !!_vm.selected
        });
      }
    }
  }) : _c('b-form-textarea', {
    attrs: {
      "id": _vm.filterId,
      "value": (_vm$getValue2 = _vm.getValue) === null || _vm$getValue2 === void 0 ? void 0 : _vm$getValue2.value,
      "placeholder": _vm.placeholder,
      "rows": "3"
    },
    on: {
      "input": function ($e) {
        return _vm.updateFilter({
          value: $e,
          selected: !!_vm.selected
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "longtextfilter-col clear-filter"
  }, [((_vm$bindValue = _vm.bindValue) === null || _vm$bindValue === void 0 ? void 0 : _vm$bindValue.length) > 0 ? _c('filter-clear-button', {
    on: {
      "click": function ($event) {
        return _vm.updateFilter('');
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('input', {
    staticClass: "labeled-checkbox",
    attrs: {
      "type": "checkbox",
      "id": _vm.filterToggleLabelId
    },
    domProps: {
      "checked": _vm.selected
    },
    on: {
      "change": function ($e) {
        return _vm.updateFilter({
          value: _vm.getValue.value,
          selected: $e.target.checked
        });
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "id": _vm.filterToggleLabelId,
      "for": _vm.filterToggleId
    }
  }, [_vm._v("Starts With")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }